import { render, staticRenderFns } from "./TaskLogTable.vue?vue&type=template&id=2727e270&scoped=true&"
import script from "./TaskLogTable.vue?vue&type=script&lang=js&"
export * from "./TaskLogTable.vue?vue&type=script&lang=js&"
import style0 from "./TaskLogTable.vue?vue&type=style&index=0&id=2727e270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2727e270",
  null
  
)

export default component.exports